import React from "react";
import Unsplash from "./Unsplash";

export const Footer = props => {
  return (
    <div className="footer">
      <p className="copyright">© 2019 Facetank Oy</p>
      <Unsplash />
    </div>
  );
};

export default Footer;
